export default "__VITE_ASSET__CPh8J_XQ__"